export enum Role {
  Kimono = 'kimono',
  Alice = 'alice',
  Maid = 'maid'
}
